export function ownerFacingGlobalError(raw: string): string {
  const text = raw.trim();
  const elevenLabsSetupCopy =
    "ElevenLabs-Stimme ist nicht verfügbar: API-Key fehlt. Nutze Piper lokal oder verbinde ElevenLabs in den Einstellungen.";
  if (
    /^(Owner-Session|Owner Auth|Owner-Freigabe|API-Zugriff|Live-Stream)/.test(text) &&
    (/Endpoint:/.test(text) || /Request-ID/.test(text))
  ) {
    return text;
  }
  if (text === "401" || /^401(?:\s|$)/.test(text)) {
    return "Owner-Session wurde vom Server nicht akzeptiert (HTTP 401). Endpoint im Fehler nicht enthalten; bitte Session erneuern oder Live-Daten neu laden.";
  }
  if (/^TTS:\s*\{/.test(text)) {
    try {
      const parsed = JSON.parse(text.replace(/^TTS:\s*/, "")) as { error?: unknown };
      if (
        parsed.error === "eleven_not_configured" ||
        parsed.error === "elevenlabs_not_configured" ||
        (typeof parsed.error === "string" && /ElevenLabs nicht konfiguriert|eleven\.api_key/i.test(parsed.error))
      ) {
        return elevenLabsSetupCopy;
      }
    } catch {
      /* fall through to raw text mappers below */
    }
  }
  if (/eleven_not_configured|elevenlabs_not_configured|ElevenLabs nicht konfiguriert|eleven\.api_key/i.test(text)) {
    return elevenLabsSetupCopy;
  }
  if (/invalid_grant|token endpoint|expired or revoked|has been expired or revoked/i.test(text)) {
    return "Connector-Freigabe abgelaufen oder widerrufen. Bitte den betroffenen Google-Connector neu verbinden; bis dahin sind diese Live-Daten nicht belastbar.";
  }
  if (/fetch failed|networkerror|network request failed|econnreset|enotfound|etimedout|timeout|stack trace|traceback|exception/i.test(text)) {
    return "Live-Daten konnten nicht belastbar geladen werden. Technische Details bleiben serverseitige Evidence; bitte Status erneut pruefen.";
  }
  if (
    /Mikrofon-Zugriff|Mikrofon-API|microphone|NotAllowedError|NotFoundError|NotReadableError|OverconstrainedError|DevicesNotFoundError|Permission denied|Permission dismissed|Permission blocked|Requested device not found/i.test(text)
  ) {
    return "Mikrofon ist nicht freigegeben oder nicht verfügbar. Bitte Browser-/Electron- und Windows-Mikrofonberechtigung prüfen und Voice danach erneut starten.";
  }
  if (/API-Zugriff nicht freigegeben|unauthorized|Bearer|Nicht autorisiert/i.test(text)) {
    return "Live-Stream oder API-Zugriff wurde nicht freigegeben. Bitte Session erneuern oder den geschuetzten Run nach Owner-Freigabe erneut öffnen.";
  }
  return text;
}
